module.exports = __webpack_public_path__ + "static/media/play-boss-shooting-failed.1befe7fa.png";